<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name" [disabled]="ngxDisabled" 
    [(ngModel)]="stationSelected" placeholder="Seleccionar Estación" (select)="changeStation($event)" style="width: 175px; display: block;">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrada
    </ng-template>

</ngx-select>